export enum PageType {
    MY_VESSELS = 'my-vessels-filter',
    INCIDENTS = 'incidents_settings',
    REPORTS = 'reports-filter',
    NETWORK_ASSETS = 'unknown_assets_settings_v2',
    USB_DEVICES = 'usb_devices',
    SOFTWARE_INVENTORY = 'software_inventory',
    NMEA_INVENTORY = 'nmea_inventory',
    METRICS = 'metrics_beta',
    VESSEL_MANAGEMENT = 'vessel_management',
    INCIDENTS_REPORT = 'incidents_report',
    OT_INVENTORY = 'ot_inventory',
}
